<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              account_balance
            </v-icon>
            <span class="title">Data Banjar</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              Banjar
              <v-icon large>account_balance</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="5">
                        <v-autocomplete
                          v-model="filter.kelurahan"
                          :items="listkelurahan"
                          item-value="id"
                          item-text="kelurahan"
                          label="Kelurahan"
                          return-object
                          @change="getBanjar">
                          <template v-slot:selection="data">
                            <v-chip small label class="chip-h-auto">
                              <div>
                                <strong>{{ data.item.kelurahan }}</strong> ( {{ data.item.kecamatan }}, {{ data.item.kabupaten }} )
                              </div>
                            </v-chip>
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title v-text="item.kelurahan"></v-list-item-title>
                              <v-list-item-subtitle>{{ item.kecamatan }}, {{ item.kabupaten }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-icon>mdi-coin</v-icon>
                            </v-list-item-action>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="7">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editBanjar(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddbanjar"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete
                                v-model="addbanjar.pos"
                                :items="listkelurahan"
                                item-value="id"
                                item-text="kelurahan"
                                label="Kelurahan"
                                return-object>
                                <template v-slot:selection="data">
                                  <v-chip label class="chip-h-auto">
                                    <div>
                                      <strong>{{ data.item.kelurahan }}</strong> ( <small>{{ data.item.kecamatan }}, {{ data.item.kabupaten }}</small> )
                                    </div>
                                  </v-chip>
                                </template>
                                <template v-slot:item="{ item }">
                                  <v-list-item-content>
                                    <v-list-item-title v-text="item.kelurahan"></v-list-item-title>
                                    <v-list-item-subtitle>{{ item.kecamatan }}, {{ item.kabupaten }}</v-list-item-subtitle>
                                  </v-list-item-content>
                                  <v-list-item-action>
                                    <v-icon>mdi-coin</v-icon>
                                  </v-list-item-action>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                class="text-uppercase-input"
                                v-model="addbanjar.nama_banjar"
                                :rules="[rules.required]"
                                label="Nama Banjar"
                                name="nama_banjar"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <div class="text-center" v-if="loading.addbanjar">
                                <v-progress-circular
                                  :width="3"
                                  color="red"
                                  indeterminate>
                                </v-progress-circular>
                              </div>
                              <v-btn
                                v-if="!loading.addbanjar"
                                large
                                block
                                :disabled="!formadd.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.banjar"
      max-width="600px"
      v-if="dmodaldata.banjar">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Update jenis pekerjaan</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatekodepos"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="dmodaldata.banjar.id_pos"
                        :items="listkelurahan"
                        item-value="id"
                        item-text="kelurahan"
                        label="Kelurahan"
                        disabled>
                        <template v-slot:selection="data">
                          <v-chip label class="chip-h-auto">
                            <div>
                              <strong>{{ data.item.kelurahan }}</strong> ( <small>{{ data.item.kecamatan }}, {{ data.item.kabupaten }}</small> )
                            </div>
                          </v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.kelurahan"></v-list-item-title>
                            <v-list-item-subtitle>{{ item.kecamatan }}, {{ item.kabupaten }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon>mdi-coin</v-icon>
                          </v-list-item-action>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.banjar.nama_banjar"
                        :rules="[rules.required]"
                        label="Nama Banjar"
                        name="namabanjar"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <alertsp :alertdata="alertupdate"></alertsp>
                      <div class="text-center" v-if="loading.editbanjar">
                        <v-progress-circular
                          :width="3"
                          color="red"
                          indeterminate>
                        </v-progress-circular>
                      </div>
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('banjar')">
                        Cancel
                      </v-btn>
                      <v-btn
                        v-if="!loading.editbanjar"
                        large
                        :disabled="!formupdate.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'BanjarAdmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      addbanjar: false,
      editbanjar: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
      status: 'active',
      kelurahan: '',
    },
    headers: [
      { text: 'Nama Banjar', value: 'nama_banjar' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addbanjar: {
      pos: '',
      nama_banjar: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    tabdata: null,
    listkelurahan: [],
    dmodal: {
      banjar: false,
    },
    dmodaldata: {
      banjar: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getKelurahan();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getKelurahan() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/kodepos/kelurahan',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                // kelurahan
                this.listkelurahan = resdata.data;
                this.filter.kelurahan = this.listkelurahan[0];
                // get banjar
                this.getBanjar();
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getBanjar() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/kodepos/banjarbypos',
            {
              params: {
                idpos: this.filter.kelurahan.id,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddbanjar.validate()) {
        // console.log(this.addbanjar);
        if (this.tokenscr) {
          this.loading.addbanjar = true;
          this.axios
            .post(
              this.api + '/api/kodepos/banjar',
              qs.stringify(
                {
                  nama_banjar: this.addbanjar.nama_banjar,
                  id_pos: this.addbanjar.pos.id,
                },
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  // this.$refs.formaddbanjar.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Banjar "' + resdata.data + '" berhasil ditambahkan!';
                  this.getBanjar();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.addbanjar = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.addbanjar = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'banjar') {
        this.dmodal.banjar = false;
      } else {
        this.dmodal.banjar = false;
      }
    },
    editBanjar(item) {
      this.alertupdate.show = false;
      this.dmodal.banjar = true;
      this.dmodaldata.banjar = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatekodepos.validate()) {
        if (this.tokenscr) {
          // console.log(this.dmodaldata.banjar);
          this.loading.editbanjar = true;
          this.axios
            .put(
              this.api + '/api/kodepos/banjar',
              qs.stringify(
                this.dmodaldata.banjar,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.banjar.nama_banjar + '" berhasil diubah!';
                  this.getBanjar();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.editbanjar = false;
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
              this.loading.editbanjar = false;
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
